import * as React from 'react';
export interface IHaiModalContext {
  onHide?: () => void;
}
export const ModalContext = React.createContext<IHaiModalContext>({} as IHaiModalContext);

/**
 * Checks whether it is inside a modal context.
 */
export const useIsInModal = () => {
  return 'onHide' in React.useContext(ModalContext);
};
